import { render, staticRenderFns } from "./EmpresaCreate.vue?vue&type=template&id=347aacf6&"
import script from "./EmpresaCreate.vue?vue&type=script&lang=js&"
export * from "./EmpresaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports